export const DESIGN = {
	border: {
		sm: 'var(--design-border-sm)',
		md: 'var(--design-border-md)',
		lg: 'var(--design-border-lg)',
		radius: {
			xs: 'var(--design-border-radius-xs)',
			sm: 'var(--design-border-radius-sm)',
			md: 'var(--design-border-radius-md)',
			lg: 'var(--design-border-radius-lg)',
		},
	},
	color: {
		background: {
			default: 'var(--design-color-background-default)',
		},
		border: {
			action: {
				active: 'var(--design-color-border-action-active)',
				chip: {
					'01': {
						default: 'var(--design-color-border-action-chip-01-default)',
					},
					'02': {
						default: 'var(--design-color-border-action-chip-02-default)',
					},
					'03': {
						default: 'var(--design-color-border-action-chip-03-default)',
					},
					'04': {
						default: 'var(--design-color-border-action-chip-04-default)',
					},
					'05': {
						default: 'var(--design-color-border-action-chip-05-default)',
					},
					'06': {
						default: 'var(--design-color-border-action-chip-06-default)',
					},
					'07': {
						default: 'var(--design-color-border-action-chip-07-default)',
					},
					'08': {
						default: 'var(--design-color-border-action-chip-08-default)',
					},
					'09': {
						default: 'var(--design-color-border-action-chip-09-default)',
					},
					'10': {
						default: 'var(--design-color-border-action-chip-10-default)',
					},
					error: {
						default: 'var(--design-color-border-action-chip-error-default)',
					},
				},
				default: 'var(--design-color-border-action-default)',
				disabled: 'var(--design-color-border-action-disabled)',
				focus: 'var(--design-color-border-action-focus)',
				hover: 'var(--design-color-border-action-hover)',
				primary: {
					active: 'var(--design-color-border-action-primary-active)',
					default: 'var(--design-color-border-action-primary-default)',
					disabled: 'var(--design-color-border-action-primary-disabled)',
					hover: 'var(--design-color-border-action-primary-hover)',
				},
				secondary: {
					active: 'var(--design-color-border-action-secondary-active)',
					default: 'var(--design-color-border-action-secondary-default)',
					disabled: 'var(--design-color-border-action-secondary-disabled)',
					hover: 'var(--design-color-border-action-secondary-hover)',
				},
				subtle: 'var(--design-color-border-action-subtle)',
				tertiary: {
					active: 'var(--design-color-border-action-tertiary-active)',
					default: 'var(--design-color-border-action-tertiary-default)',
					disabled: 'var(--design-color-border-action-tertiary-disabled)',
					hover: 'var(--design-color-border-action-tertiary-hover)',
				},
			},
			feedback: {
				success: {
					default: 'var(--design-color-border-feedback-success-default)',
				},
				warning: {
					default: 'var(--design-color-border-feedback-warning-default)',
				},
				info: {
					default: 'var(--design-color-border-feedback-info-default)',
				},
				error: {
					default: 'var(--design-color-border-feedback-error-default)',
				},
			},
			neutral: {
				default: 'var(--design-color-border-neutral-default)',
				inverted: 'var(--design-color-border-neutral-inverted)',
				subtle: 'var(--design-color-border-neutral-subtle)',
			},
		},
		divider: {
			neutral: {
				default: 'var(--design-color-divider-neutral-default)',
				inverted: 'var(--design-color-divider-neutral-inverted)',
			},
		},
		icon: {
			action: {
				default: 'var(--design-color-icon-action-default)',
				disabled: 'var(--design-color-icon-action-disabled)',
				inverted: 'var(--design-color-icon-action-inverted)',
				primary: {
					default: 'var(--design-color-icon-action-primary-default)',
					hover: 'var(--design-color-icon-action-primary-hover)',
					active: 'var(--design-color-icon-action-primary-active)',
					disabled: 'var(--design-color-icon-action-primary-disabled)',
				},
				secondary: {
					default: 'var(--design-color-icon-action-secondary-default)',
					hover: 'var(--design-color-icon-action-secondary-hover)',
					active: 'var(--design-color-icon-action-secondary-active)',
					disabled: 'var(--design-color-icon-action-secondary-disabled)',
				},
				subtle: 'var(--design-color-icon-action-subtle)',
				tertiary: {
					default: 'var(--design-color-icon-action-tertiary-default)',
					hover: 'var(--design-color-icon-action-tertiary-hover)',
					active: 'var(--design-color-icon-action-tertiary-active)',
					disabled: 'var(--design-color-icon-action-tertiary-disabled)',
				},
			},
			feedback: {
				success: {
					default: 'var(--design-color-icon-feedback-success-default)',
				},
				warning: {
					default: 'var(--design-color-icon-feedback-warning-default)',
				},
				info: {
					default: 'var(--design-color-icon-feedback-info-default)',
				},
				error: {
					default: 'var(--design-color-icon-feedback-error-default)',
				},
			},
			neutral: {
				default: 'var(--design-color-icon-neutral-default)',
			},
		},
		surface: {
			action: {
				chip: {
					'01': {
						default: 'var(--design-color-surface-action-chip-01-default)',
						hover: 'var(--design-color-surface-action-chip-01-hover)',
					},
					'02': {
						default: 'var(--design-color-surface-action-chip-02-default)',
						hover: 'var(--design-color-surface-action-chip-02-hover)',
					},
					'03': {
						default: 'var(--design-color-surface-action-chip-03-default)',
						hover: 'var(--design-color-surface-action-chip-03-hover)',
					},
					'04': {
						default: 'var(--design-color-surface-action-chip-04-default)',
						hover: 'var(--design-color-surface-action-chip-04-hover)',
					},
					'05': {
						default: 'var(--design-color-surface-action-chip-05-default)',
						hover: 'var(--design-color-surface-action-chip-05-hover)',
					},
					'06': {
						default: 'var(--design-color-surface-action-chip-06-default)',
						hover: 'var(--design-color-surface-action-chip-06-hover)',
					},
					'07': {
						default: 'var(--design-color-surface-action-chip-07-default)',
						hover: 'var(--design-color-surface-action-chip-07-hover)',
					},
					'08': {
						default: 'var(--design-color-surface-action-chip-08-default)',
						hover: 'var(--design-color-surface-action-chip-08-hover)',
					},
					'09': {
						default: 'var(--design-color-surface-action-chip-09-default)',
						hover: 'var(--design-color-surface-action-chip-09-hover)',
					},
					10: {
						default: 'var(--design-color-surface-action-chip-10-default)',
						hover: 'var(--design-color-surface-action-chip-10-hover)',
					},
					error: {
						default: 'var(--design-color-surface-action-chip-error-default)',
						hover: 'var(--design-color-surface-action-chip-error-hover)',
					},
				},
				default: 'var(--design-color-surface-action-default)',
				disabled: 'var(--design-color-surface-action-disabled)',
				hover: 'var(--design-color-surface-action-hover)',
				menu: {
					default: 'var(--design-color-surface-action-menu-default)',
					active: 'var(--design-color-surface-action-menu-active)',
					hover: 'var(--design-color-surface-action-menu-hover)',
				},
				primary: {
					default: 'var(--design-color-surface-action-primary-default)',
					hover: 'var(--design-color-surface-action-primary-hover)',
					active: 'var(--design-color-surface-action-primary-active)',
					disabled: 'var(--design-color-surface-action-primary-disabled)',
				},
				secondary: {
					default: 'var(--design-color-surface-action-secondary-default)',
					hover: 'var(--design-color-surface-action-secondary-hover)',
					active: 'var(--design-color-surface-action-secondary-active)',
					disabled: 'var(--design-color-surface-action-secondary-disabled)',
				},
			},
			feedback: {
				success: {
					default: 'var(--design-color-surface-feedback-success-default)',
				},
				warning: {
					default: 'var(--design-color-surface-feedback-warning-default)',
				},
				info: {
					default: 'var(--design-color-surface-feedback-info-default)',
				},
				error: {
					default: 'var(--design-color-surface-feedback-error-default)',
				},
			},
			neutral: {
				default: 'var(--design-color-surface-neutral-default)',
				grey: 'var(--design-color-surface-neutral-grey)',
				primary: 'var(--design-color-surface-neutral-primary)',
				secondary: 'var(--design-color-surface-neutral-secondary)',
				subtle: 'var(--design-color-surface-neutral-subtle)',
				subtle02: 'var(--design-color-surface-neutral-subtle-02)',
				subtle03: 'var(--design-color-surface-neutral-subtle-03)',
			},
			statistic: {
				1: 'var(--design-color-surface-statistic-1)',
				2: 'var(--design-color-surface-statistic-2)',
				3: 'var(--design-color-surface-statistic-3)',
				4: 'var(--design-color-surface-statistic-4)',
				5: 'var(--design-color-surface-statistic-5)',
				6: 'var(--design-color-surface-statistic-6)',
				7: 'var(--design-color-surface-statistic-7)',
				8: 'var(--design-color-surface-statistic-8)',
				9: 'var(--design-color-surface-statistic-9)',
				10: 'var(--design-color-surface-statistic-10)',
			},
		},
		text: {
			action: {
				active: 'var(--design-color-text-action-active)',
				chip: {
					'01': {
						default: 'var(--design-color-text-action-chip-01-default)',
					},
					'02': {
						default: 'var(--design-color-text-action-chip-02-default)',
					},
					'03': {
						default: 'var(--design-color-text-action-chip-03-default)',
					},
					'04': {
						default: 'var(--design-color-text-action-chip-04-default)',
					},
					'05': {
						default: 'var(--design-color-text-action-chip-05-default)',
					},
					'06': {
						default: 'var(--design-color-text-action-chip-06-default)',
					},
					'07': {
						default: 'var(--design-color-text-action-chip-07-default)',
					},
					'08': {
						default: 'var(--design-color-text-action-chip-08-default)',
					},
					'09': {
						default: 'var(--design-color-text-action-chip-09-default)',
					},
					10: {
						default: 'var(--design-color-text-action-chip-10-default)',
					},
					error: {
						default: 'var(--design-color-text-action-chip-error-default)',
					},
				},
				default: 'var(--design-color-text-action-default)',
				disabled: 'var(--design-color-text-action-disabled)',
				hover: 'var(--design-color-text-action-hover)',
				inverted: 'var(--design-color-text-action-inverted)',
				primary: {
					default: 'var(--design-color-text-action-primary-default)',
					hover: 'var(--design-color-text-action-primary-hover)',
					active: 'var(--design-color-text-action-primary-active)',
					disabled: 'var(--design-color-text-action-primary-disabled)',
				},
				secondary: {
					default: 'var(--design-color-text-action-secondary-default)',
					hover: 'var(--design-color-text-action-secondary-hover)',
					active: 'var(--design-color-text-action-secondary-active)',
					disabled: 'var(--design-color-text-action-secondary-disabled)',
				},
				tertiary: {
					default: 'var(--design-color-text-action-tertiary-default)',
					hover: 'var(--design-color-text-action-tertiary-hover)',
					active: 'var(--design-color-text-action-tertiary-active)',
					disabled: 'var(--design-color-text-action-tertiary-disabled)',
				},
			},
			feedback: {
				error: {
					default: 'var(--design-color-text-feedback-error-default)',
				},
			},
			neutral: {
				default: 'var(--design-color-text-neutral-default)',
				disabled: 'var(--design-color-text-neutral-disabled)',
				inverted: 'var(--design-color-text-neutral-inverted)',
				subtle: 'var(--design-color-text-neutral-subtle)',
			},
		},
	},
	component: {
		spacing: {
			mobile: 'var(--design-component-spacing-mobile)',
			tablet: 'var(--design-component-spacing-tablet)',
			desktop: 'var(--design-component-spacing-desktop)',
		},
	},
	content: {
		footer: {
			spacing: {
				mobile: 'var(--design-content-footer-spacing-mobile)',
				tablet: 'var(--design-content-footer-spacing-tablet)',
				desktop: 'var(--design-content-footer-spacing-desktop)',
			},
		},
		max: {
			width: 'var(--design-content-max-width)',
		},
		width: {
			mobile: 'var(--design-content-width-mobile)',
			tablet: 'var(--design-content-width-tablet)',
		},
	},
	font: {
		xs: 'var(--design-font-xs)',
		sm: 'var(--design-font-sm)',
		md: 'var(--design-font-md)',
		lg: 'var(--design-font-lg)',
		xl: 'var(--design-font-xl)',
		xxl: 'var(--design-font-xxl)',
		xxxl: 'var(--design-font-xxxl)',
		weight: {
			bold: 'var(--design-font-weight-bold)',
			semi: {
				bold: 'var(--design-font-weight-semi-bold)',
			},
			normal: 'var(--design-font-weight-normal)',
		},
	},
	shadow: {
		md: 'var(--design-shadow-md)',
	},
	spacing: {
		xxs: 'var(--design-spacing-xxs)',
		xs: 'var(--design-spacing-xs)',
		sm: 'var(--design-spacing-sm)',
		md: 'var(--design-spacing-md)',
		lg: 'var(--design-spacing-lg)',
		xl: 'var(--design-spacing-xl)',
		xxl: 'var(--design-spacing-xxl)',
		xxxl: 'var(--design-spacing-xxxl)',
	},
} as const;
